// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__2hB6Q","hideOnTablet":"styles_hideOnTablet__F1u4_","hideOnMobile":"styles_hideOnMobile__3PTm5","priceColumn":"styles_priceColumn__estLT"};